export default "__VITE_ASSET__CdvU5lWX__"